/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Confirm_Approve_TitleInputs */



/**
* | output |
* | --- |
* | "Approve commission entries?" |
*
* @param {Partner_Admin_Commission_Confirm_Approve_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_confirm_approve_title = /** @type {((inputs?: Partner_Admin_Commission_Confirm_Approve_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Confirm_Approve_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Provisionseinträge freigeben?")
	return /** @type {LocalizedString} */ ("Approve commission entries?")
});